<div style="display: flex; flex-direction: column; height: 100%; width: 100%;">
  <!-- Multi-cohort view -->
  <div *ngIf="isMultiCohort" style="display: flex; flex-direction: column; height: 100%; width: 100%;">
    <div class="multi-cohort-container">
      <div *ngFor="let cohort of cohorts; let i = index" class="cohort-chart-wrapper">
        <div class="cohort-title">
          {{ cohort.title }}
        </div>
        <div
          [id]="'chart-container' + id + '-' + i"
          [ngStyle]="{
            height: height,
            width: '100%',
            flex: '1 1 auto'
          }"
        ></div>
      </div>
    </div>
    <!-- Shared Highcharts legend container for multi-cohort -->
    <div *ngIf="isMultiCohort" id="shared-legend-container-{{id}}" style="width: 100%; display: flex; justify-content: center; margin-top: 0.5rem;"></div>
  </div>

  <!-- Single chart view -->
  <div *ngIf="!isMultiCohort"
    [ngStyle]="{
      height: height,
      width: '100%',
      flex: '1 1 auto'
    }"
  >
    <div
      [id]="'chart-container' + id"
      [ngStyle]="{
        height: height,
        width: '100%'
      }"
    ></div>
  </div>

  <ng-content select=".insights, [insights]"></ng-content>
</div>
